import { Analysis } from '../../types';
import { roles } from '../../config/roles';
import Modal from '../Modal';
import DownloadMenu from '../DownloadMenu';
import { formatParagraphs, markdownToHtml } from '../../utils/textUtils';
import { Calendar, User } from 'lucide-react';

interface AnalysisModalProps {
  analysis: Analysis | null;
  onClose: () => void;
}

export default function AnalysisModal({ analysis, onClose }: AnalysisModalProps) {
  if (!analysis) return null;

  const role = roles.find(r => r.id === analysis.roleId);
  const paragraphs = formatParagraphs(analysis.analysis);

  return (
    <Modal
      isOpen={!!analysis}
      onClose={onClose}
      title={analysis.fileName}
    >
      <div className="space-y-6">
        <div className="flex justify-between items-start">
          <div className="space-y-2">
            <div className="flex items-center space-x-2 text-sm text-navy-500 dark:text-navy-400">
              <User className="h-4 w-4" />
              <span>{role?.name}</span>
            </div>
            <div className="flex items-center space-x-2 text-xs text-navy-400 dark:text-navy-500">
              <Calendar className="h-3.5 w-3.5" />
              <span>{new Date(analysis.createdAt).toLocaleDateString('pt-BR')}</span>
            </div>
          </div>

          <DownloadMenu
            content={analysis.analysis}
            fileName={analysis.fileName}
          />
        </div>

        <div className="prose dark:prose-invert max-w-none space-y-4 text-navy-800 dark:text-navy-200">
          {paragraphs.map((paragraph, index) => (
            <p
              key={index}
              dangerouslySetInnerHTML={{
                __html: markdownToHtml(paragraph)
              }}
            />
          ))}
        </div>
      </div>
    </Modal>
  );
}
